module.exports = __webpack_public_path__ + "static/media/MSU.074b2f46.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/MSU.png
// module id = 131
// module chunks = 0